import { CommApiInstance } from "Utils/CommApiInstance";

const MbpAthnTknInqApi = async (
    certNum:string,
) => {
    
    return await CommApiInstance.post(`/athn/idnt_mthd/mbp/tkn`,{
        apiBody:{
            certNum:certNum
        },
    })
    .then((Resp) => Resp.data);
    
}
export default MbpAthnTknInqApi;